var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup"},[_c('signup-form',{attrs:{"disabled":_vm.loading,"showSignupMessage":_vm.showSignupMessage,"success":_vm.success},on:{"signup":_vm.signup,"confirm":_vm.confirmSignup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }